import DOMPurify from 'dompurify';

export function safeBase64ToBlob(base64: string, maxSizeMB: number = 10) {
	const sanitized = DOMPurify.sanitize(base64);
	const cleaned = sanitized.startsWith('data:') ? sanitized.split(',')[1] : sanitized;
	const pureBase64 = cleaned.replace(/\s/g, '');

	const sizeInBytes = (pureBase64.length * 3) / 4;
	const sizeInMB = sizeInBytes / (1024 * 1024);
	if (sizeInMB > maxSizeMB) throw new Error(`Картинка слишком большая: ${sizeInMB.toFixed(2)} MB`);

	const byteCharacters = atob(pureBase64);
	const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
	return new Blob([new Uint8Array(byteNumbers)], { type: 'image/png' });
}